import { useEffect, useMemo, useState } from 'react';
import { PageOrientation } from '../../../../api/model/document';

export const ZOOM_CONFIG = {
  BREAKPOINTS: {
    SMALL: 1450,
    MEDIUM: 1500,
    LARGE: 1575,
  },
  LANDSCAPE_ADDITION: 250,
  ZOOM_LEVELS: [0.7, 0.9, 1],
  DEFAULT_ZOOM: 1,
} as const;

const getLandscapeAdjustment = (orientation: PageOrientation): number => {
  return orientation === PageOrientation.Landscape
    ? ZOOM_CONFIG.LANDSCAPE_ADDITION
    : 0;
};

export const getAdjustedBreakpoints = (orientation: PageOrientation) => {
  const adjustment = getLandscapeAdjustment(orientation);
  return {
    small: ZOOM_CONFIG.BREAKPOINTS.SMALL + adjustment,
    medium: ZOOM_CONFIG.BREAKPOINTS.MEDIUM + adjustment,
    large: ZOOM_CONFIG.BREAKPOINTS.LARGE + adjustment,
  };
};

export const useZoomConfig = (orientation: PageOrientation) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const breakpoints = useMemo(
    () => getAdjustedBreakpoints(orientation),
    [orientation],
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const defaultZoom = useMemo(() => {
    if (windowWidth < breakpoints.medium) {
      return ZOOM_CONFIG.ZOOM_LEVELS[0];
    } else if (windowWidth < breakpoints.large) {
      return ZOOM_CONFIG.ZOOM_LEVELS[1];
    }
    return ZOOM_CONFIG.DEFAULT_ZOOM;
  }, [breakpoints, windowWidth]);

  const shouldOpenDocPropertiesPanel = useMemo(() => {
    return windowWidth >= breakpoints.small;
  }, [breakpoints, windowWidth]);

  return {
    defaultZoom,
    shouldOpenDocPropertiesPanel,
  };
};
